// extracted by mini-css-extract-plugin
export default {"linkDetailsTable":"AnalyticsPdfLinkDetails_linkDetailsTable__8QlKi","linkRow":"AnalyticsPdfLinkDetails_linkRow__n716j","linkUrl":"AnalyticsPdfLinkDetails_linkUrl__AY2D7"};